import React from 'react';
import styled from 'styled-components';
import AccordionMenu from 'components/shared/AccordionMenu';
import classnames from 'classnames';

const ListOfLinksContainer = styled.div`
  & > h3 {
    font-family: 'Whitney Bold', Arial, sans-serif;
    font-size: 1rem;
    font-weight: 700;
    color: #fff;
    line-height: 1.2;
    margin-bottom: 0.375rem;
  }

  & > h2 {
    font-family: 'Whitney Bold', Arial, sans-serif;
    font-size: 1rem;
    font-weight: 700;
    text-transform: uppercase;
    color: #fff;
    margin-bottom: 0.9375rem;
    border-bottom: 1px solid hsla(0, 0%, 100%, 0.2);
  }

  & > ul > li > a {
    font-size: 1rem;
    font-weight: 400;
    color: #fff;
    line-height: 1.2;
    text-decoration: none;
    margin-bottom: 0.3125rem;
    padding-top: 1px;
    padding-bottom: 1px;
  }

  margin-bottom: 1.0625rem;
`;

const ListOfLinks = ({ children }) => (
  <ListOfLinksContainer>{children}</ListOfLinksContainer>
);

const ShopContent = ({ platinumEcomBaseUrl }) => (
  <>
    <ListOfLinks>
      <h3 className="category-header">Formulas for Equine Health</h3>
      <ul className="category-links-list">
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/health-categories`}
            className="category-link"
          >
            See All Formulas
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h3 className="category-header">Wellness Foundation Formulas</h3>
      <ul className="category-links-list">
        <li>
          <a
            href={`${platinumEcomBaseUrl}/platinum-performance-equine/eplag--kepppla--set.html`}
            className="category-link"
          >
            Platinum Performance® Equine
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/platinum-performance-cj/epcjg--kepppcj--set.html`}
            className="category-link"
          >
            Platinum Performance® CJ
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/platinum-performance-gi/epgig--kepppgi--set.html`}
            className="category-link"
          >
            Platinum Performance® GI
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/wellness-formulas-comparison.html`}
            className="category-link"
          >
            Compare All Foundation Formulas
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h3 className="category-header">Other Popular Formulas</h3>
      <ul className="category-links-list">
        <li>
          <a
            href={`${platinumEcomBaseUrl}/bio-sponge/ebiop--keppbio--set.html`}
            className="category-link"
          >
            Bio-Sponge®
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/bio-sponge-paste-60cc-syringe/EBIOS.html`}
            className="category-link"
          >
            Bio-Sponge® Paste
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/platinum-balance/ebalp--keppbal--set.html`}
            className="category-link"
          >
            Platinum Balance®
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/healthy-weight/EHEAL.html`}
            className="category-link"
          >
            Healthy Weight Oil and Pump
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/platinum-gastric-support/epgap--kepppga--set.html`}
            className="category-link"
          >
            Platinum Gastric Support®
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/platinum-power/epowp--kepppom--set.html`}
            className="category-link"
          >
            Platinum Power®
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/platinum-skin-and-allergy/eskip--keppski--set.html`}
            className="category-link"
          >
            Platinum Skin &amp; Allergy
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h2 className="category-header">Health Categories</h2>
      <ul className="category-links-list">
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/health-categories`}
            className="category-link"
          >
            See All Categories
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/health-categories/horse-overall-wellness-supplements`}
            className="category-link"
          >
            Overall Health
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/health-categories/horse-allergy-supplements`}
            className="category-link"
          >
            Allergies
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/health-categories/horse-bone-health`}
            className="category-link"
          >
            Bone &amp; Tendon Health
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/health-categories/horse-calming-supplements`}
            className="category-link"
          >
            Calming
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/health-categories/horse-coat-health`}
            className="category-link"
          >
            Coat Health
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/health-categories/horse-digestive-health`}
            className="category-link"
          >
            Digestion
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/health-categories/horse-electrolyte-non-sweating`}
            className="category-link"
          >
            Electrolytes &amp; Non Sweating
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/health-categories/horse-hoof-supplements`}
            className="category-link"
          >
            Hoof Care
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/health-categories/horse-joint-supplements`}
            className="category-link"
          >
            Joint Support
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/health-categories/horse-metabolic`}
            className="category-link"
          >
            Metabolic Support
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/health-categories/horse-neurologic-support`}
            className="category-link"
          >
            Neurologic Support
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/health-categories/horse-strength-recovery`}
            className="category-link"
          >
            Performance &amp; Recovery
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/health-categories/horse-reproduction-fertility`}
            className="category-link"
          >
            Reproduction &amp; Fertility
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/health-categories/horse-senior-care`}
            className="category-link"
          >
            Senior Care
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/health-categories/horse-weight-gain`}
            className="category-link"
          >
            Weight Management
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h3 className="category-header">Platinum Colic Coverage®</h3>
      <ul>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/health-categories/colic-coverage-qualifying-supplements`}
            className="category-link"
          >
            Formulas Eligible for
            <br />
            Platinum Colic Coverage<sup>®</sup>
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h2 className="category-header">Personalized</h2>
      <h3 className="category-header">Platinum PAKs®</h3>
      <ul className="category-links-list">
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/platinum-paks-horse`}
            className="category-link"
          >
            What is a Platinum PAK®?
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/platinum-paks-horse/create-a-custom-pak-horse`}
            className="category-link"
          >
            Build a PAK
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h3 className="category-header">Buying For a Barn?</h3>
      <ul className="category-links-list">
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/barns`}
            className="category-link"
          >
            Barn Program
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/barns/bulk-discount`}
            className="category-link"
          >
            Bulk Pricing Guide
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h3 className="category-header">Offers & Rewards</h3>
      <ul className="category-links-list">
        <li>
          <a
            href={`${platinumEcomBaseUrl}/auto-ship.html`}
            className="category-link"
          >
            Auto-ship &amp; Save
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/military-first-responder-program.html`}
            className="category-link"
          >
            Military &amp; First
            <br />
            Responders Program
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/platinum-rewards.html`}
            className="category-link"
          >
            Platinum Rewards
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/referafriendweb`}
            className="category-link"
          >
            Refer a Friend – Give $20, Get $20
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h3 className="category-header">Auto-Ship</h3>
      <ul className="category-links-list">
        <li>
          <a
            href={`${platinumEcomBaseUrl}/auto-ship.html`}
            className="category-link"
          >
            Auto-Ship FAQ
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h3 className="category-header">Logo Wear</h3>
      <ul className="category-links-list">
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/horse-apparel`}
            className="category-link"
          >
            Apparel &amp; Merchandise
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h3 className="category-header">International</h3>
      <ul className="category-links-list">
        <li>
          <a
            href="https://www.platinumperformance.ca"
            className="category-link"
          >
            Canada
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/international/mexico`}
            className="category-link"
          >
            Mexico
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses-international.html`}
            className="category-link"
          >
            All Countries
          </a>
        </li>
      </ul>
    </ListOfLinks>
  </>
);

const WellnessContent = ({ platinumEcomBaseUrl }) => (
  <>
    <>
      <ListOfLinks>
        <h3 className="category-header">Daily Wellness Foundation Formulas</h3>
        <ul className="category-links-list">
          <li>
            <a
              href={`${platinumEcomBaseUrl}/feature-story-platinum-performance-equine`}
              className="category-link"
            >
              Platinum Performance® Equine: Wellness &amp; Performance
            </a>
          </li>
          <li>
            <a
              href={`${platinumEcomBaseUrl}/feature-story-platinum-performance-cj`}
              className="category-link"
            >
              Platinum Performance® CJ: Platinum Performance® CJ: Wellness &amp;
              Performance + Complete Joint
            </a>
          </li>
          <li>
            <a
              href={`${platinumEcomBaseUrl}/feature-story-platinum-performance-gi`}
              className="category-link"
            >
              Platinum Performance® GI: Platinum Performance® GI: Wellness &amp;
              Performance + Digestive Care
            </a>
          </li>
        </ul>
      </ListOfLinks>
      <ListOfLinks>
        <ul className="category-links-list">
          <li>
            <a
              href={`${platinumEcomBaseUrl}/wellness-formulas-comparison`}
              className="category-link"
            >
              Compare All Foundation Formulas
            </a>
          </li>
        </ul>
      </ListOfLinks>
      <ListOfLinks>
        <h2 className="category-header">Buying For a Barn?</h2>
        <ul className="category-links-list">
          <li>
            <a
              href={`${platinumEcomBaseUrl}/horses/barns`}
              className="category-link"
            >
              Barn Program
            </a>
          </li>
          <li>
            <a
              href={`${platinumEcomBaseUrl}/horses/barns/bulk-discount`}
              className="category-link"
            >
              Bulk Pricing Guide
            </a>
          </li>
        </ul>
      </ListOfLinks>
    </>
    <ListOfLinks>
      <h2 className="category-header">All Formulas</h2>
      <ul className="category-links-list">
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/health-categories`}
            className="category-link"
          >
            See All Formulas
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/nutrient-finder.html`}
            className="category-link"
          >
            Nutrient Finder
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h3 className="category-header">Platinum Product Finder</h3>
      <ul>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/help-me-choose-product.html`}
            className="category-link"
          >
            Personalized Recommendations for Your Horse
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h2>Horse Care</h2>
      <ul>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/articles/horse-care.html`}
            className="category-link"
          >
            How to Attend to a New Horse
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/articles.html`}
            className="category-link"
          >
            Platinum Magazine
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/podcasts.html`}
            className="category-link"
          >
            Platinum Podcasts
          </a>
        </li>
      </ul>
    </ListOfLinks>
  </>
);

const PerformanceContent = ({ platinumEcomBaseUrl }) => (
  <>
    <ListOfLinks>
      <h2 className="category-header">English</h2>
      <ul className="category-links-list">
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/performance-horse/english-horse/dressage-horse`}
            className="category-link"
          >
            Dressage
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/performance-horse/english-horse/eventing-horse`}
            className="category-link"
          >
            Eventing
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/performance-horse/english-horse/hunter-horse`}
            className="category-link"
          >
            Hunter
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/performance-horse/english-horse/jumping-horse`}
            className="category-link"
          >
            Jumping
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <ul className="category-links-list">
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/performance-horse/english-horse/driving`}
            className="category-link"
          >
            Driving
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/performance-horse/racing-horse/endurance-horse`}
            className="category-link"
          >
            Endurance
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <ul className="category-links-list">
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/performance-horse/english-sports-riders`}
            className="category-link"
          >
            All English Disciplines
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h2 className="category-section">Western</h2>
      <ul className="category-links-list">
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/performance-horse/western-horse/barrel-racing-horse`}
            className="category-link"
          >
            Barrel Racing
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/performance-horse/western-horse/cutting-horse`}
            className="category-link"
          >
            Cutting
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/performance-horse/western-horse/mounted-shooting-horse`}
            className="category-link"
          >
            Mounted Shooting
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/performance-horse/western-horse/reined-cow-horse`}
            className="category-link"
          >
            Reined Cow Horse
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/performance-horse/western-horse/reining-horse`}
            className="category-link"
          >
            Reining
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/performance-horse/western-horse/rodeo-horse`}
            className="category-link"
          >
            Rodeo
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/performance-horse/western-horse/team-roping-horse`}
            className="category-link"
          >
            Breakaway Roping &amp; Team Roping
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/performance-horse/western-horse/trail-riding-horse`}
            className="category-link"
          >
            Trail Riding
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/performance-horse/western-horse/western-pleasure-riding-horse`}
            className="category-link"
          >
            Western Pleasure
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <ul className="category-links-list">
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/performance-horse/western-sports-riders`}
            className="category-link"
          >
            All Western Disciplines
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h2 className="category-section">Resources For Riders</h2>
    </ListOfLinks>
    <ListOfLinks>
      <h3 className="category-header">Formulas Safe for Sport</h3>
      <ul className="category-links-list">
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/performance-horse/peace-of-mind-for-competition`}
            className="category-link"
          >
            Peace of Mind for Competition
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h3 className="category-header">Support for Athletic Horses</h3>
      <ul className="category-links-list">
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/horse-conditions/horse-performance-recovery`}
            className="category-link"
          >
            Performance & Recovery
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h3 className="category-header">Platinum Team Riders</h3>
      <ul className="category-links-list">
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses-platinum-ambassadors-athletes.html`}
            className="category-link"
          >
            See What Formulas the Team Uses
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/it-starts-within.html`}
            className="category-link"
          >
            It Starts Within Videos
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h3 className="category-header">Platinum Podcasts</h3>
      <ul className="category-links-list">
        <li>
          <a
            href={`${platinumEcomBaseUrl}/podcasts.html`}
            className="category-link"
          >
            Learn About Equine Health
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h3 className="category-header">Buying For a Barn?</h3>
      <ul className="category-links-list">
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/barns`}
            className="category-link"
          >
            Barn Program
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/barns/bulk-discount`}
            className="category-link"
          >
            Bulk Pricing Guide
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <ul className="category-links-list">
        <h3 className="category-header">Results</h3>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses-supplement-reviews.html`}
            className="category-link"
          >
            Success Stories &amp; Reviews
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/tellusaboutyourhorse.html`}
            className="category-link"
          >
            Share Your Success Story
          </a>
        </li>
      </ul>
    </ListOfLinks>
  </>
);

const ConditionsContent = ({ platinumEcomBaseUrl }) => (
  <>
    <ListOfLinks>
      <ul className="category-links-list">
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/horse-conditions`}
            className="category-link"
          >
            See All Conditions
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <ul className="category-links-list">
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/horse-conditions/horse-allergy-support`}
            className="category-link"
          >
            Allergies
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/horse-conditions/horse-bone-health`}
            className="category-link"
          >
            Bone Health
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/horse-conditions/horse-calming-supplements`}
            className="category-link"
          >
            Calming
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/horse-conditions/horse-digestive-health`}
            className="category-link"
          >
            Digestive Health
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/horse-conditions/horse-hoof-supplements`}
            className="category-link"
          >
            Hoof Care
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/horse-conditions/horse-joint-supplements`}
            className="category-link"
          >
            Joint Health
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/horse-conditions/horse-non-sweating`}
            className="category-link"
          >
            Non-sweating
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/horse-conditions/horse-performance-recovery`}
            className="category-link"
          >
            Performance &amp; Recovery
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/horse-conditions/horse-reproduction-fertility`}
            className="category-link"
          >
            Reproduction &amp; Fertility
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/horse-conditions/horse-skin-coat-supplements`}
            className="category-link"
          >
            Skin &amp; Coat
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/horse-conditions/horse-weight-gain-and-management`}
            className="category-link"
          >
            Weight Management
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h2 className="category-header">Supplementing for Health</h2>
      <h3 className="category-header">Daily Wellness Formula</h3>
      <ul className="category-links-list">
        <li>
          <a
            href={`${platinumEcomBaseUrl}/platinum-performance-equine/eplag--kepppla--set.html`}
            className="category-link"
          >
            Platinum Performance® Equine
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/platinum-performance-cj/epcjg--kepppcj--set.html`}
            className="category-link"
          >
            Platinum Performance® CJ
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/platinum-performance-gi/epgig--kepppgi--set.html`}
            className="category-link"
          >
            Platinum Performance® GI
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <ul className="category-links-list">
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/health-categories`}
            className="category-link"
          >
            See All Products
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h2 className="category-section">Results</h2>
      <ul className="category-links-list">
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses-supplement-reviews.html`}
            className="category-link"
          >
            Success Stories &amp; Reviews
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/tellusaboutyourhorse.html`}
            className="category-link"
          >
            Share Your Success Story
          </a>
        </li>
      </ul>
    </ListOfLinks>

    <ListOfLinks>
      <h2 className="category-header">Resources &amp; Programs</h2>
      <h3 className="category-header">Platinum Colic Coverage®</h3>
      <ul className="category-links-list">
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/platinumcoliccoverage.html`}
            className="category-link"
          >
            About Platinum Colic Coverage®
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/platinumcoliccoverageproducts.html`}
            className="category-link"
          >
            Qualifying Formulas
          </a>
        </li>
        <li>
          <a
            href="/colic-coverage/apply/owner_profile"
            className="category-link"
            rel="nofollow noopener noreferrer"
          >
            Enroll in Platinum Colic Coverage®
          </a>
        </li>
      </ul>
    </ListOfLinks>

    <ListOfLinks>
      <h3 className="category-header">Platinum Product Finder</h3>
      <ul>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/help-me-choose-product.html`}
            className="category-link"
          >
            Recommendations for Your Horse
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h3 className="category-header">More Resources</h3>
      <ul className="category-links-list">
        <li>
          <a
            href={`${platinumEcomBaseUrl}/body-condition-score.html`}
            className="category-link"
          >
            Body Condition Score
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/barns`}
            className="category-link"
          >
            Platinum Barns: Buy in Bulk
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/articles.html`}
            className="category-link"
          >
            Platinum Magazine
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/podcasts.html`}
            className="category-link"
          >
            Platinum Podcasts
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/performance-horse`}
            className="category-link"
          >
            Shop by Sport
          </a>
        </li>
      </ul>
    </ListOfLinks>
  </>
);

const ColicCoverageContent = ({ platinumEcomBaseUrl }) => (
  <>
    <ListOfLinks>
      <h2 className="category-header">
        Complimentary Platinum
        <br />
        Colic Coverage®
      </h2>
      <ul>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/platinumcoliccoverage.html`}
            className="category-link"
          >
            Program Overview
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/platinumcoliccoverageproducts.html`}
            className="category-link"
          >
            Shop Qualifying Formulas
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/platinumcoliccoverage/wellness-requirements.html`}
            className="category-link"
          >
            Program Requirements
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/platinumcoliccoverage/dosage-guide.html`}
            className="category-link"
          >
            Supplement Dosage Guide
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/coliccoverage-faq.html`}
            className="category-link"
          >
            FAQs
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h2 className="category-section">Enroll Now</h2>
      <ul className="category-links-list">
        <li>
          <a
            href="/colic-coverage/apply/owner_profile"
            className="category-link"
            rel="nofollow noopener noreferrer"
          >
            Enroll Online in Minutes
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h2 className="category-section">Enrolled Horses</h2>
      <ul>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/platinumcoliccoverage-reminders.html`}
            className="category-link"
          >
            Reminders to Maintain Coverage
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/platinumcoliccoveragecovered.html`}
            className="category-link"
          >
            Confirming Your Horse is Covered
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/platinumcoliccoverage-reimbursement.html`}
            className="category-link"
          >
            Applying For Reimbursement
          </a>
        </li>
      </ul>
    </ListOfLinks>
  </>
);

const VeterinariansContent = ({ platinumEcomBaseUrl }) => (
  <>
    <ListOfLinks>
      <ul className="category-links-list">
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses-veterinarians.html`}
            className="category-link"
          >
            Nutrition in Your Practice
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/veterinarian/directdispense.html`}
            className="category-link"
          >
            Direct Dispense
            <sup>®</sup>
            Program
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/horse-conditions/horse-advanced-support.html`}
            className="category-link"
          >
            PlatinumVET™ Formulas
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h2 className="category-header">Special Veterinary Programs</h2>
      <ul>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/aaevt-program.html`}
            className="category-link"
          >
            Platinum AAEVT & NAVTA Program
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/veterinary-student-advancement-program.html`}
            className="category-link"
          >
            Platinum Veterinary Student Program
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h2 className="category-section">Veterinarians in Canada</h2>
      <ul className="category-links-list">
        <li>
          <a
            href="https://www.platinumperformance.ca/"
            className="category-link"
          >
            Nutrition in Your Practice
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h2 className="category-section">Veterinary Heritage</h2>
      <ul className="category-links-list">
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/our-story-veterinarians.html`}
            className="category-link"
          >
            Our Story
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/platinum-advisors-veterinarians.html`}
            className="category-link"
          >
            Our Team
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h2 className="category-section">In-Practice Trials</h2>
      <ul className="category-links-list">
        <li>
          <a
            href={`${platinumEcomBaseUrl}/veterinarian/request-trial.html`}
            className="category-link"
          >
            Request an In-Practice Trial
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h2 className="category-section">Veterinary Resources</h2>
      <ul className="category-links-list">
        <li>
          <a
            href={`${platinumEcomBaseUrl}/research-veterinarians.html`}
            className="category-link"
          >
            Nutritional Research
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/protocols.html`}
            className="category-link"
          >
            Veterinary Protocols
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/on-demand-ce-lectures.html`}
            className="category-link"
          >
            Continuing Education
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/veterinarian/request-resources.html`}
            className="category-link"
          >
            Order Marketing Materials
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/marketing-materials.html`}
            className="category-link"
          >
            Social Media Resources
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ul className="category-links-list">
      <li>
        <a
          href={`${platinumEcomBaseUrl}/login`}
          className="category-link font-weight-bold"
        >
          Log In/Register
        </a>
      </li>
    </ul>
  </>
);

const InsidePlatinumContent = ({ platinumEcomBaseUrl }) => (
  <>
    {' '}
    <ListOfLinks>
      <h3 className="category-header">Magazine & Podcasts</h3>
      <ul>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/articles.html`}
            className="category-link"
          >
            Latest Issue
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/all-articles.html`}
            className="category-link"
          >
            All Articles
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/platinum-magazine-request.html`}
            className="category-link"
          >
            Subscribe
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/podcasts.html`}
            className="category-link"
          >
            Platinum Podcasts
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/videos.html`}
            className="category-link"
          >
            Platinum Videos
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h3 className="category-header">Science</h3>
      <ul>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/body-condition-score.html`}
            className="category-link"
          >
            Body Condition Scoring
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/research.html`}
            className="category-link"
          >
            Nutritional Research
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/articles/the-extra-mile.html`}
            className="category-link"
          >
            The Extra Mile
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/nutrient-finder.html`}
            className="category-link"
          >
            Nutrient Finder
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h3 className="category-header">Quality</h3>
      <ul>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/quality.html`}
            className="category-link"
          >
            Why Quality Matters
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h3 className="category-header">Results</h3>
      <ul>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses-supplement-reviews.html`}
            className="category-link"
          >
            Client Stories &amp; Reviews
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/it-starts-within.html`}
            className="category-link"
          >
            It Starts Within Videos
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/veterinarian-reviews.html`}
            className="category-link"
          >
            Reviews by Veterinarians
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses-platinum-ambassadors-athletes.html`}
            className="category-link"
          >
            Team Platinum Riders
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h3 className="category-header">About Us</h3>
      <ul>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/our-story.html`}
            className="category-link"
          >
            Our Story
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/articles/limitless.html`}
            className="category-link"
          >
            Platinum Performance &amp; Zoetis
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/platinum-advisors.html`}
            className="category-link"
          >
            Our Team
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses-careers.html`}
            className="category-link"
          >
            Careers
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses-partners-and-affiliations.html`}
            className="category-link"
          >
            Partners &amp; Affiliations
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses-platinum-ambassadors-athletes.html`}
            className="category-link"
          >
            Platinum Team Riders
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/barns`}
            className="category-link"
          >
            Barn Program
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/horses/barns/bulk-discount`}
            className="category-link"
          >
            Bulk Pricing Guide
          </a>
        </li>
        <li>
          <a
            href={`${platinumEcomBaseUrl}/podcasts.html`}
            className="category-link"
          >
            Platinum Podcasts
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h3 className="category-header">FAQs</h3>
      <ul>
        <li>
          <a
            className="category-link"
            href={`${platinumEcomBaseUrl}/horses-faq.html`}
          >
            FAQ
          </a>
        </li>
        <li>
          <a
            className="category-link"
            href={`${platinumEcomBaseUrl}/platinum-rewards-faq.html`}
          >
            Rewards FAQ
          </a>
        </li>
        <li>
          <a
            className="category-link"
            href={`${platinumEcomBaseUrl}/auto-ship.html`}
          >
            Equine Auto-Ship Program
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h3 className="category-header">Rewards</h3>
      <ul>
        <li>
          <a
            className="category-link"
            href={`${platinumEcomBaseUrl}/platinum-rewards.html`}
          >
            Platinum Rewards
          </a>
        </li>
      </ul>
    </ListOfLinks>
  </>
);

const StyledDiv = styled.div`
  & li.accordion-component-item {
    border-bottom: 1px solid hsla(0, 0%, 100%, 0.2);
  }

  .accordion-component-body {
    padding-left: 1.5625rem;
  }
`;

export const MenuLinks = ({ show, platinumEcomBaseUrl }) => {
  return (
    <StyledDiv className={classnames('mobile-menu', { show: !!show })}>
      <ul className="nav navbar-nav" role="menu">
        <li className="nav-item" role="menuitem">
          <a
            href={`${platinumEcomBaseUrl}/horses.html`}
            role="button"
            className="nav-link active"
          >
            Horses
          </a>
          <div className="header-nav-subcategory">
            <AccordionMenu>
              <AccordionMenu.Item>
                <AccordionMenu.ItemHeader>
                  <a className="main-nav-link">Shop</a>
                </AccordionMenu.ItemHeader>
                <AccordionMenu.ItemBody>
                  <ShopContent platinumEcomBaseUrl={platinumEcomBaseUrl} />
                </AccordionMenu.ItemBody>
              </AccordionMenu.Item>
              <AccordionMenu.Item>
                <AccordionMenu.ItemHeader>
                  <a className="main-nav-link">Wellness</a>
                </AccordionMenu.ItemHeader>
                <AccordionMenu.ItemBody>
                  <WellnessContent platinumEcomBaseUrl={platinumEcomBaseUrl} />
                </AccordionMenu.ItemBody>
              </AccordionMenu.Item>
              <AccordionMenu.Item>
                <AccordionMenu.ItemHeader>
                  <a className="main-nav-link">Performance</a>
                </AccordionMenu.ItemHeader>
                <AccordionMenu.ItemBody>
                  <PerformanceContent
                    platinumEcomBaseUrl={platinumEcomBaseUrl}
                  />
                </AccordionMenu.ItemBody>
              </AccordionMenu.Item>
              <AccordionMenu.Item>
                <AccordionMenu.ItemHeader>
                  <a className="main-nav-link">Conditions</a>
                </AccordionMenu.ItemHeader>
                <AccordionMenu.ItemBody>
                  <ConditionsContent
                    platinumEcomBaseUrl={platinumEcomBaseUrl}
                  />
                </AccordionMenu.ItemBody>
              </AccordionMenu.Item>
              <AccordionMenu.Item>
                <AccordionMenu.ItemHeader>
                  <a className="main-nav-link">Colic Coverage</a>
                </AccordionMenu.ItemHeader>
                <AccordionMenu.ItemBody>
                  <ColicCoverageContent
                    platinumEcomBaseUrl={platinumEcomBaseUrl}
                  />
                </AccordionMenu.ItemBody>
              </AccordionMenu.Item>
              <AccordionMenu.Item>
                <AccordionMenu.ItemHeader>
                  <a className="main-nav-link">Veterinarians</a>
                </AccordionMenu.ItemHeader>
                <AccordionMenu.ItemBody>
                  <VeterinariansContent
                    platinumEcomBaseUrl={platinumEcomBaseUrl}
                  />
                </AccordionMenu.ItemBody>
              </AccordionMenu.Item>
              <AccordionMenu.Item>
                <AccordionMenu.ItemHeader>
                  <a className="main-nav-link">Inside Platinum</a>
                </AccordionMenu.ItemHeader>
                <AccordionMenu.ItemBody>
                  <InsidePlatinumContent
                    platinumEcomBaseUrl={platinumEcomBaseUrl}
                  />
                </AccordionMenu.ItemBody>
              </AccordionMenu.Item>
            </AccordionMenu>
          </div>
        </li>

        <li className="nav-item" role="menuitem">
          <a
            href={`${platinumEcomBaseUrl}/dogs-cats`}
            role="button"
            className="nav-link "
          >
            Dogs &amp; Cats
          </a>
        </li>
      </ul>
    </StyledDiv>
  );
};
